// react components
import React, {
    useState,
} from 'react'
import {
    useSelector,
} from 'react-redux'
import Tooltip from '@mui/material/Tooltip';

// data
import {
    defaultReduxState,
} from 'data'

// pages
import {
    // TranslationForm,
} from 'pages'

// serializer
import {
    MainFontSerializer,
    TranslationHelper,
} from 'serializers/site'

// props
type FormLabel825Props = {
    fonts?: MainFontSerializer[]
    formInput?: 'address_json' | 'image' | 'image_crop' | 'pdf' | 'text' | 'textArea' | 'richText'
    helperText?: string
    helperTextNoTooltip?: boolean
    helperTextPosition?: 'belowLabel'
    label: string
    marginBottom?: boolean
    marginTop?: boolean
    object?: any
    name: string
    onRefresh?: () => void
    tinymceStylesObject?: any
    tinymceStylesString?: string
    translation?: TranslationHelper
    translationDefaultValue?: string | number
}

// main
export const FormLabel825: React.FC<FormLabel825Props> = React.memo(({
    fonts,
    formInput,
    helperText,
    helperTextNoTooltip,
    helperTextPosition,
    label,
    marginBottom,
    marginTop,
    object,
    name,
    onRefresh,
    tinymceStylesObject,
    tinymceStylesString,
    translation,
    translationDefaultValue,
}) => {

    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const [showTranslation, setShowTranslation] = useState(false)

    return (
        <div
            className={`form-label-825${helperTextPosition ? ` ${helperTextPosition}` : ''}`}
            style={{
                marginBottom: marginBottom ? '10px' : '0',
                marginTop: marginTop ? '10px' : '0',
            }}
        >
            <label
                className='form-label-wrap'
                htmlFor={name}
            >
                <span>{label}</span>
                {name === 'name' && object?.name?.startsWith('(copy) - ') && (
                    <span className='form-label-copy'>{reduxText[11105]}</span>
                )}
            </label>
            <div className='form-label-helper-wrap'>
                {(translation?.objectId && translationDefaultValue && Object.keys(translationDefaultValue).length > 0) && (
                    <span
                        className='form-label-helper pointer'
                        onClick={() => setShowTranslation(true)}
                    >
                        {reduxText[10221]}
                    </span>
                )}
                {helperText && (
                    <>
                        {helperTextNoTooltip ? (
                            <span className='form-label-helper'>
                                {helperText}
                            </span>
                        ) : (
                            <Tooltip
                                arrow
                                title={helperText}
                            >
                                <i className='form-label-helper-icon mo-new-icon-question-circle-regular' />
                            </Tooltip>
                        )}
                    </>
                )}
            </div>
            {/* {showTranslation && (
                <TranslationForm
                    fieldName={name}
                    fonts={fonts}
                    formInput={formInput!}
                    onRefresh={onRefresh}
                    setIsOpen={setShowTranslation}
                    tinymceStylesObject={tinymceStylesObject}
                    tinymceStylesString={tinymceStylesString!}
                    translation={translation!}
                    translationDefaultValue={translationDefaultValue!}
                />
            )} */}
        </div>
    )
})
